import { Component, OnChanges, Input } from '@angular/core';

@Component({
  selector: 'app-hrm',
  templateUrl: './hrm.component.html',
  styleUrls: ['./hrm.component.scss'],
})
export class HrmComponent implements OnChanges {
  @Input() avgHeart: number;
  zone = 5;
  angle = -35;
  codes = {
    1: 'Warm Up',
    2: 'Easy',
    3: 'Aerobic',
    4: 'Threshold',
    5: 'Maximum',
  };

  constructor() {}

  ngOnChanges() {
    this.calculateZones();
  }

  calculateZones() {
    const athleteYear = localStorage.getItem('age');
    const age = athleteYear
      ? new Date().getUTCFullYear() - parseInt(localStorage.getItem('age'), 10)
      : 30;
    const maxHeartRate = localStorage.getItem('heartrate');
    const max = maxHeartRate ? Number(maxHeartRate) : 220 - age;
    if (this.avgHeart < max * 0.9 && this.avgHeart >= max * 0.8) {
      this.zone = 4;
    } else if (this.avgHeart < max * 0.8 && this.avgHeart >= max * 0.7) {
      this.zone = 3;
    } else if (this.avgHeart < max * 0.7 && this.avgHeart >= max * 0.6) {
      this.zone = 2;
    } else if (this.avgHeart < max * 0.6) {
      this.zone = 1;
    } else {
      this.zone = 5;
    }
    if (this.avgHeart < max * 0.5) {
      this.angle = -150;
    } else if (this.avgHeart > max) {
      this.angle = 150;
    } else {
      const percentage = (max - this.avgHeart) / max;
      this.angle = 150 - percentage * 600;
    }
  }
}
